var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var MenuItem = function (_a) {
    var menuItem = _a.menuItem;
    return (_jsx("a", __assign({ "aria-label": menuItem.label + " Page", href: menuItem.url, tabIndex: 0, className: "menu-items__link-item subfooter__item-links block max-w-full truncate text-left text-xs font-extralight", title: menuItem.label, "aria-labelledby": "sf-item" }, { children: menuItem.label }), void 0));
};
export default MenuItem;
